import { toast as sonnerToast } from "@h2j-data-team/ui";

type ToastOptions = {
  description?: string;
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
};

/**
 * Centralized toast utility over the library's Sonner `toast` (one Sonner copy).
 * Change default behavior here to affect all toasts in the app.
 */
export const toast = {
  success: (message: string, options?: ToastOptions) => {
    sonnerToast.success(message, options);
  },

  error: (message: string, options?: ToastOptions) => {
    sonnerToast.error(message, options);
  },

  info: (message: string, options?: ToastOptions) => {
    sonnerToast.info(message, options);
  },

  warning: (message: string, options?: ToastOptions) => {
    sonnerToast.warning(message, options);
  },

  loading: (message: string, options?: ToastOptions) => {
    return sonnerToast.loading(message, options);
  },

  dismiss: (toastId?: string | number) => {
    sonnerToast.dismiss(toastId);
  },

  /**
   * Promise toast - shows loading, then success/error based on promise result
   */
  promise: <T>(
    promise: Promise<T>,
    options: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: unknown) => string);
    },
  ) => {
    return sonnerToast.promise(promise, options);
  },
};
